import { useQuery, UseQueryResult } from '@tanstack/react-query';
import {
  fetchVehicleMakes,
  fetchVehicleModels,
  fetchVehiclePopularMakes,
} from '../services/api';
import { VehicleMakeDTO, VehicleModelDTO } from './VehicleDTO';

export function useVehicleMakes(
  query: string,
): UseQueryResult<VehicleMakeDTO[]> {
  return useQuery(
    ['vehicle-makes-list', query],
    () => fetchVehicleMakes(query),
    {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      enabled: !!query,
    },
  );
}

export function useVehiclePopularMakes(): UseQueryResult<VehicleMakeDTO[]> {
  return useQuery(['vehicle-makes-popular'], () => fetchVehiclePopularMakes(), {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}

export function useVehicleModels(
  query: string | null | undefined,
  makeId?: number,
): UseQueryResult<VehicleModelDTO[]> {
  return useQuery(
    ['vehicle-models-list', { makeId, query }],
    () => fetchVehicleModels(makeId as number, query),
    {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      enabled: !!makeId,
    },
  );
}
